export const IMAGE = 'image' as const;
export const AUDIO = 'audio' as const;
export const VIDEO = 'video' as const;
